export class SprintCommitmentRecalculatingError extends Error {
	constructor() {
		super();
		this.message = 'sprint commitment recalculating';
	}
}
